/**
 * App-wide SweetAlert2 toast defaults (layout is in index.css).
 * Import once from index.js so every Swal.fire({ toast: true }) is consistent.
 */
import Swal from "sweetalert2";

const nativeFire = Swal.fire.bind(Swal);

function attachToastHoverPause(popup) {
  popup.addEventListener("mouseenter", Swal.stopTimer);
  popup.addEventListener("mouseleave", Swal.resumeTimer);
}

Swal.fire = function cmsSwalFire(...args) {
  if (typeof args[0] === "string") {
    return nativeFire(...args);
  }

  const options = args[0];
  if (!options || typeof options !== "object" || !options.toast) {
    return nativeFire(...args);
  }

  const {
    customClass: userClass = {},
    didOpen: userDidOpen,
    showConfirmButton,
    timer,
    timerProgressBar,
    position,
    ...rest
  } = options;

  return nativeFire({
    position: position ?? "top-end",
    showConfirmButton: showConfirmButton ?? false,
    timer: timer ?? 2500,
    timerProgressBar: timerProgressBar ?? false,
    ...rest,
    customClass: {
      popup: "cms-swal-toast",
      title: "cms-swal-toast__title",
      htmlContainer: "cms-swal-toast__text",
      icon: "cms-swal-toast__icon",
      ...userClass,
    },
    didOpen: (popup) => {
      attachToastHoverPause(popup);
      if (typeof userDidOpen === "function") {
        userDidOpen(popup);
      }
    },
  });
};
